<template>
    <div class="row" :style="rowStyle">
        <div class="col-12">
            <div class="row">
                <div class="form-inline col-md-2">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="grey lighten-1" class="tooltip-small">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Select the data fields for your custom audience.</span>
                    </v-tooltip>

                    <i class="fas fa-hdd"></i> <span style="padding-left: 5px;"> Data</span>
                </div>

                <div class="form-group col-md-3" v-if="[analyses.types.cohorts].includes(analysisType)">
                    <template>
                        <v-container fluid>
                            <v-autocomplete
                                v-model="cohorts"
                                :items="$store.getters['CreateAudienceStore/getCohortsAll'](dataSetOrder)"
                                label="Cohorts"
                                :rules="[requiredCohorts]"
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('cohorts_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('cohorts_' + dataSetOrder)"
                            >

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_cohorts" placeholder="Search" @input="searchItems(dataSetOrder, 'cohorts')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-autocomplete>
                        </v-container>
                    </template>
                </div><!--form-group-->

                <div class="form-group col-md-2" v-if="[analyses.types.poi, analyses.types.competitors, analyses.types.anonymized].includes(analysisType)">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="signal_providers"
                                :items="$store.getters['CreateAudienceStore/getSignalProvidersAll'](dataSetOrder)"
                                label="Signal Provider"
                                multiple
                                :rules="[requiredSignalsProviders]"
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('signal_providers_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('signal_providers_' + dataSetOrder)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ signal_providers.length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_signal_providers" placeholder="Search" @input="searchItems(dataSetOrder, 'signal_providers')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item
                                        ripple
                                        @click="toggleItems(dataSetOrder, 'signal_providers')"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="$store.getters['CreateAudienceStore/getSignalProvidersSelected'](dataSetOrder).length > 0 ? 'indigo darken-4' : ''">
                                                {{ showingIcon(dataSetOrder, 'signal_providers') }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->

                <div class="form-group col-md-2" v-if="[analyses.types.anonymized].includes(analysisType)">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="countries"
                                :items="$store.getters['CreateAudienceStore/getCountriesAll'](dataSetOrder)"
                                label="Country"
                                @change="countriesChanged"
                                multiple
                                :rules="[requiredCountries]"
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('countries_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('countries_' + dataSetOrder)"
                            >
                                <template v-slot:item="{ active, item, attrs, on }">
                                    <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                        <v-list-item-action>
                                            <v-checkbox :input-value="active"></v-checkbox>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ item.text }} <small>({{ item.value }})</small>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>

                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ $store.getters['CreateAudienceStore/getCountriesSelected'](dataSetOrder).length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_countries" placeholder="Search" @input="searchItems(dataSetOrder, 'countries')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item
                                        ripple
                                        @click="toggleItems(dataSetOrder, 'countries')"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="$store.getters['CreateAudienceStore/getCountriesSelected'](dataSetOrder).length > 0 ? 'indigo darken-4' : ''">
                                                {{ showingIcon(dataSetOrder, 'countries') }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->

                <div class="form-group col-md-2" v-if="[analyses.types.poi, analyses.types.competitors].includes(analysisType)">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="segments"
                                :items="$store.getters['CreateAudienceStore/getSegmentsAll'](dataSetOrder)"
                                label="Segments"
                                @change="segmentsChanged"
                                multiple
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('segments_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('segments_' + dataSetOrder)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ $store.getters['CreateAudienceStore/getSegmentsSelected'](dataSetOrder).length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_segments" placeholder="Search" @input="searchItems(dataSetOrder, 'segments')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item
                                        ripple
                                        @click="toggleItems(dataSetOrder, 'segments')"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="$store.getters['CreateAudienceStore/getSegmentsSelected'](dataSetOrder).length > 0 ? 'indigo darken-4' : ''">
                                                {{ showingIcon(dataSetOrder, 'segments') }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->

                <div class="form-group" v-if="[analyses.types.poi, analyses.types.competitors, 'Cross'].includes(analysisType)" :class="['Cross'].includes(analysisType) ? 'col-md-3' : 'col-md-2'">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="categories"
                                :items="$store.getters['CreateAudienceStore/getCategoriesAll'](dataSetOrder)"
                                label="Category"
                                @change="categoriesChanged"
                                multiple
                                :rules="[requiredCategories, requiredCategoriesCross, maximumCategories]"
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('categories_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('categories_' + dataSetOrder)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ $store.getters['CreateAudienceStore/getCategoriesSelected'](dataSetOrder).length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_categories" placeholder="Search" @input="searchItems(dataSetOrder, 'categories')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item
                                        ripple
                                        @click="toggleItems(dataSetOrder, 'categories')"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="$store.getters['CreateAudienceStore/getCategoriesSelected'](dataSetOrder).length > 0 ? 'indigo darken-4' : ''">
                                                {{ showingIcon(dataSetOrder, 'categories') }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                    <small v-if="['Cross'].includes(analysisType)"><strong>{{ $store.getters['CreateAudienceStore/getCategoriesSelected'](dataSetOrder).length }}</strong> categories from <strong>1</strong> allowed were selected.</small>
                </div><!--form-group-->

                <div class="form-group" v-if="[analyses.types.poi, analyses.types.competitors, 'Cross'].includes(analysisType)" :class="['Cross', 'CompetitorsData'].includes(analysisType) ? 'col-md-3' : 'col-md-2'">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="brands"
                                :items="$store.getters['CreateAudienceStore/getBrandsAll'](dataSetOrder)"
                                label="Brands"
                                @change="brandsChanged"
                                multiple
                                :rules="[requiredPOIAnalysisData, requiredCrossBrands]"
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('brands_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('brands_' + dataSetOrder)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ $store.getters['CreateAudienceStore/getBrandsSelected'](dataSetOrder).length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_brands" placeholder="Search" @input="searchItems(dataSetOrder, 'brands')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item
                                        ripple
                                        @click="toggleItems(dataSetOrder, 'brands')"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="$store.getters['CreateAudienceStore/getBrandsSelected'](dataSetOrder).length > 0 ? 'indigo darken-4' : ''">
                                                {{ showingIcon(dataSetOrder, 'brands') }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->

                <div class="form-group col-md-2" v-if="[analyses.types.poi, analyses.types.competitors, 'Cross'].includes(analysisType)">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="locations"
                                :items="$store.getters['CreateAudienceStore/getLocationsAll'](dataSetOrder)"
                                label="Locations"
                                @change="locationsChanged"
                                multiple
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('locations_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('locations_' + dataSetOrder)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ $store.getters['CreateAudienceStore/getLocationsSelected'](dataSetOrder).length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_locations" placeholder="Search" @input="searchItems(dataSetOrder, 'locations')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->
            </div>

            <div class="row" v-if="[analyses.types.poi, analyses.types.competitors, 'Cross'].includes(analysisType)">
                <div class="form-inline col-md-2">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="grey lighten-1" class="tooltip-small">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Select your targeted audience's location fields by country, state, city or zipcode.</span>
                    </v-tooltip>

                    <i class="fas fa-location-arrow"></i> <span style="padding-left: 5px;"> Location </span>
                </div>
                <div class="form-group col-md-2">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="countries"
                                :items="$store.getters['CreateAudienceStore/getCountriesAll'](dataSetOrder)"
                                label="Country"
                                multiple
                                @change="countriesChanged"
                                :rules="[requiredCountries]"
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('countries_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('countries_' + dataSetOrder)"
                            >
                                <template v-slot:item="{ active, item, attrs, on }">
                                    <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                        <v-list-item-action>
                                            <v-checkbox :input-value="active"></v-checkbox>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ item.text }} <small>({{ item.value }})</small>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>

                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ $store.getters['CreateAudienceStore/getCountriesSelected'](dataSetOrder).length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_countries" placeholder="Search" @input="searchItems(dataSetOrder, 'countries')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item
                                        ripple
                                        @click="toggleItems(dataSetOrder, 'countries')"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="$store.getters['CreateAudienceStore/getCountriesSelected'](dataSetOrder).length > 0 ? 'indigo darken-4' : ''">
                                                {{ showingIcon(dataSetOrder, 'countries') }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->

                <div class="form-group col-md-2">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="states"
                                :items="$store.getters['CreateAudienceStore/getStatesAll'](dataSetOrder)"
                                label="State"
                                @change="statesChanged"
                                multiple
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('states_' + dataSetOrder) ||
                                    !isUSASelected($store.getters['CreateAudienceStore/getCountriesSelected'](dataSetOrder))"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('states_' + dataSetOrder)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ $store.getters['CreateAudienceStore/getCountriesSelected'](dataSetOrder).length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_states" placeholder="Search" @input="searchItems(dataSetOrder, 'states')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item
                                        ripple
                                        @click="toggleItems(dataSetOrder, 'states')"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="$store.getters['CreateAudienceStore/getCountriesSelected'](dataSetOrder).length > 0 ? 'indigo darken-4' : ''">
                                                {{ showingIcon(dataSetOrder, 'states') }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->

                <div class="form-group col-md-2">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="dmas"
                                :items="$store.getters['CreateAudienceStore/getDmasAll'](dataSetOrder)"
                                label="DMA"
                                multiple
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('dmas_' + dataSetOrder) ||
                                    !isUSASelected($store.getters['CreateAudienceStore/getCountriesSelected'](dataSetOrder))"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('dmas_' + dataSetOrder)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ $store.getters['CreateAudienceStore/getDmasSelected'](dataSetOrder).length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_dmas" placeholder="Search" @input="searchItems(dataSetOrder, 'dmas')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item
                                        ripple
                                        @click="toggleItems(dataSetOrder, 'dmas')"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="$store.getters['CreateAudienceStore/getDmasSelected'](dataSetOrder).length > 0 ? 'indigo darken-4' : ''">
                                                {{ showingIcon(dataSetOrder, 'dmas') }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->

                <div class="form-group col-md-2">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="cities"
                                :items="$store.getters['CreateAudienceStore/getCitiesAll'](dataSetOrder)"
                                label="City"
                                multiple
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('cities_' + dataSetOrder) ||
                                    !isUSASelected($store.getters['CreateAudienceStore/getCountriesSelected'](dataSetOrder))"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('cities_' + dataSetOrder)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ cities.length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_cities" placeholder="Search" @input="searchItems(dataSetOrder, 'cities')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item
                                        ripple
                                        @click="toggleItems(dataSetOrder, 'cities')"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="$store.getters['CreateAudienceStore/getCitiesSelected'](dataSetOrder).length > 0 ? 'indigo darken-4' : ''">
                                                {{ showingIcon(dataSetOrder, 'cities') }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->
                <div class="form-group col-md-2">
                    <v-textarea
                        v-model="zip_codes"
                        label="Zip Codes"
                        rows="1"
                        hint="One zip code in one row"
                        auto-grow
                        :rules="[zipCodeValidation]"
                    ></v-textarea>
                </div><!--form-group-->
            </div>

            <div class="row" v-if="[analyses.types.poi, analyses.types.competitors, 'Cross'].includes(analysisType) && $store.getters.isPowerUser">
                <div class="form-inline col-md-2">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="grey lighten-1" class="tooltip-small">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Insert custom location identifiers?</span>
                    </v-tooltip>

                    <i class="fas fa-location-arrow"></i> <span style="padding-left: 5px;">Location IDs</span>
                </div>

                <div class="form-group col-md-2 push-down-36">
                    <v-switch
                        v-model="insert_custom_locations"
                        inset
                    ></v-switch>
                </div><!--form-group-->
            </div>

            <div class="row" v-if="[analyses.types.poi, analyses.types.competitors, 'Cross'].includes(analysisType) && $store.getters.isPowerUser && insert_custom_locations">
                <div class="form-inline col-md-2">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="grey lighten-1" class="tooltip-small">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Insert Custom Locations Identifiers, <br> one Location ID in one row.</span>
                    </v-tooltip>

                    <i class="fas fa-location-arrow"></i> <span style="padding-left: 5px;"> LocationIDs</span>
                </div>
                <div class="form-group col-md-4">
                    <v-textarea
                        v-model="location_ids"
                        label="Location Identifiers"
                        rows="3"
                        hint="One location ID in one row"
                        :rules="[locationsIdsValidation]"
                    ></v-textarea>
                </div><!--form-group-->
            </div>
        </div>
    </div>
</template>

<script>
import analyses from "../../../../mixin/analyses"
import api from "../../../../api/analyses/activations";
import {mapState} from "vuex";
export default {
    name: "LocationData",
    mixins: [analyses],
    props: [
        'dataSetOrder',
        'rowStyle',
        'analysisType'
    ],
    data: () => ({
        requiredSignalsProviders: v => v && v.length > 0 || 'Signal Provider field is required',
        requiredCountries: v => v && v.length > 0 || 'Country field is required',
        requiredCohorts: v => v && v > 0 || 'Cohorts field is required',
    }),
    methods: {
        requiredPOIAnalysisData(v) {
            if ([this.analyses.types.poi, this.analyses.types.competitors].includes(this.$store.getters['CreateAudienceStore/getAnalysisType'](this.dataSetOrder))) {
                if (v.length < 1) {
                    return 'Brands field is required'
                }
            }

            return true
        },
        requiredCrossBrands(v) {
            if (this.analysisType === 'Cross') {
                if (v.length < 1) {
                    return 'Brands field is required'
                }
            }

            return true
        },
        requiredCategories(v) {
            if ([this.analyses.types.poi, this.analyses.types.competitors].includes(this.analysisType)) {
                if (v.length < 1 && !this.checkCategories) {
                    return 'Category field is required'
                }
            }

            return true
        },
        requiredCategoriesCross(v) {
            if (this.analysisType === 'Cross') {
                if (v.length < 1 || !this.checkBrandsAvailable) {
                    return 'Selected categories doesn\'t contain brands'
                }
            }

            return true
        },
        maximumCategories(v) {
            if (this.analysisType === 'Cross') {
                if (v.length > 1) {
                    return 'Only 1 category can be selected.'
                }
            }

            return true
        },
        segmentsChanged() {
            if (! [this.analyses.additional.cross_visitation].includes(this.analysisType)) {
                this.$store.dispatch('CreateAudienceStore/fetchPoiData', {
                    dataSetOrder: this.dataSetOrder,
                    analysisType: this.analysisType
                })
            }
        },
        categoriesChanged() {
            if (this.analysisType === this.analyses.additional.cross_visitation) {
                if (this.$store.getters['CreateAudienceStore/getCategoriesSelected'](this.dataSetOrder).length) {
                    this.$store.dispatch('CreateAudienceStore/fetchBrandsByCategories', {
                        dataSetOrder: this.dataSetOrder,
                        analysisType: this.analysisType
                    })
                }
            } else {
                this.$store.dispatch('CreateAudienceStore/fetchPoiData', {
                    dataSetOrder: this.dataSetOrder,
                    analysisType: this.analysisType
                })
            }
        },
        brandsChanged() {
            if ([this.analyses.types.poi, this.analyses.types.competitors, this.analyses.additional.cross_visitation].includes(this.analysisType)) {
                this.$store.dispatch('CreateAudienceStore/fetchLocationsByBrands', this.dataSetOrder)
                this.$store.dispatch('CreateAudienceStore/fetchCountriesByBrands', this.dataSetOrder)
            }
        },
        locationsChanged() {
            if (this.$store.getters['CreateAudienceStore/getLocationsSelected'](this.dataSetOrder).length) {
                this.$store.dispatch('CreateAudienceStore/fetchCountriesByLocations', this.dataSetOrder)
            }
        },
        countriesChanged() {
            if ([this.analyses.types.poi, this.analyses.types.competitors].includes(this.analysisType)) {
                this.$store.dispatch('CreateAudienceStore/fetchStatesByCountries', this.dataSetOrder)
                this.$store.dispatch('CreateAudienceStore/fetchDataByCountries', this.dataSetOrder)
            } else if ([this.analyses.additional.cross_visitation].includes(this.analysisType)) {
                if (this.$store.getters['CreateAudienceStore/getCountriesSelected'](this.dataSetOrder).length) {
                    this.$store.dispatch('CreateAudienceStore/fetchDataByCountries', this.dataSetOrder)
                }
            }
        },
        statesChanged() {
            this.$store.dispatch('CreateAudienceStore/fetchCitiesByStates', this.dataSetOrder)
        }
    },
    computed: {
        cohorts: {
            get() {
                return this.$store.getters['CreateAudienceStore/getCohortsSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_COHORT', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_cohorts: {
            get() {
                return this.$store.getters['CreateAudienceStore/getCohortsSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_COHORTS_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        signal_providers: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSignalProvidersSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_SIGNAL_PROVIDERS', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_signal_providers: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSignalProvidersSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_SIGNAL_PROVIDERS_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        segments: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSegmentsSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_SEGMENTS', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_segments: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSegmentsSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_SEGMENTS_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        categories: {
            get() {
                return this.$store.getters['CreateAudienceStore/getCategoriesSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_CATEGORIES', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_categories: {
            get() {
                return this.$store.getters['CreateAudienceStore/getCategoriesSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_CATEGORIES_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        brands: {
            get() {
                return this.$store.getters['CreateAudienceStore/getBrandsSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_BRANDS', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_brands: {
            get() {
                return this.$store.getters['CreateAudienceStore/getBrandsSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_BRANDS_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        locations: {
            get() {
                return this.$store.getters['CreateAudienceStore/getLocationsSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_LOCATIONS', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_locations: {
            get() {
                return this.$store.getters['CreateAudienceStore/getLocationsSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_LOCATIONS_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        countries: {
            get() {
                return this.$store.getters['CreateAudienceStore/getCountriesSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_COUNTRIES', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_countries: {
            get() {
                return this.$store.getters['CreateAudienceStore/getCountriesSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_COUNTRIES_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        states: {
            get() {
                return this.$store.getters['CreateAudienceStore/getStatesSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_STATES', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_states: {
            get() {
                return this.$store.getters['CreateAudienceStore/getStatesSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_STATES_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        dmas: {
            get() {
                return this.$store.getters['CreateAudienceStore/getDmasSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_DMAS', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_dmas: {
            get() {
                return this.$store.getters['CreateAudienceStore/getDmasSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_DMAS_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        cities: {
            get() {
                return this.$store.getters['CreateAudienceStore/getCitiesSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_CITIES', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_cities: {
            get() {
                return this.$store.getters['CreateAudienceStore/getCitiesSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_CITIES_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        insert_custom_locations: {
            get() {
                return this.$store.getters['CreateAudienceStore/getLocationsInsertCustomStatus'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_LOCATIONS_INSERT_CUSTOM', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        location_ids: {
            get() {
                return this.$store.getters['CreateAudienceStore/getLocationsCustomIds'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_LOCATIONS_IDS', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        zip_codes: {
            get() {
                return this.$store.getters['CreateAudienceStore/getZipCodes'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_ZIP_CODES', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        checkCategories() {
            if (this.$store.getters['CreateAudienceStore/getBrandsSelected'](this.dataSetOrder).length > 0) {
                return true
            } else {
                return false
            }
        },
        checkBrandsAvailable() {
            if (this.$store.getters['CreateAudienceStore/getBrandsSelected'](this.dataSetOrder).length > 0) {
                return true
            } else {
                return false
            }
        },
    },
    mounted() {
        if ([this.analyses.types.poi, this.analyses.types.competitors, this.analyses.types.anonymized].includes(this.analysisType)) {
            this.$store.dispatch('CreateAudienceStore/fetchSignalProviders', this.dataSetOrder)
        }
        if ([this.analyses.types.anonymized].includes(this.analysisType)) {
            this.$store.dispatch('CreateAudienceStore/fetchCountries', this.dataSetOrder)
        }

        if ([this.analyses.types.poi, this.analyses.types.competitors].includes(this.analysisType)) {
            this.$store.dispatch('CreateAudienceStore/fetchPoiData', {
                dataSetOrder: this.dataSetOrder,
                analysisType: this.analysisType
            })
        }

        if ([this.analyses.types.cohorts].includes(this.analysisType)) {
            this.$store.dispatch('CreateAudienceStore/fetchCohorts', this.dataSetOrder)
        }

        if ([this.analyses.additional.cross_visitation].includes(this.analysisType)) {
            this.$store.dispatch('CreateAudienceStore/fetchCategories', {
                dataSetOrder: this.dataSetOrder,
                analysisType: this.analysisType
            })
        }
    },
    watch: {
        analysisType: function () {
            if ([this.analyses.types.poi, this.analyses.types.competitors, this.analyses.types.anonymized].includes(this.analysisType)) {
                this.$store.dispatch('CreateAudienceStore/fetchSignalProviders', this.dataSetOrder)
            }
            if ([this.analyses.types.anonymized].includes(this.analysisType)) {
                this.$store.dispatch('CreateAudienceStore/fetchCountries', this.dataSetOrder)
            }
            if ([this.analyses.types.cohorts].includes(this.analysisType)) {
                this.$store.dispatch('CreateAudienceStore/fetchCohorts', this.dataSetOrder)
            }
        },
        // segments: function () {
        //     if (! [this.analyses.additional.cross_visitation].includes(this.analysisType)) {
        //         this.$store.dispatch('CreateAudienceStore/fetchPoiData', {
        //             dataSetOrder: this.dataSetOrder,
        //             analysisType: this.analysisType
        //         })
        //     }
        // },
        // categories: function () {
        //     if (this.analysisType === this.analyses.additional.cross_visitation) {
        //         this.$store.dispatch('CreateAudienceStore/fetchBrandsByCategories', {
        //             dataSetOrder: this.dataSetOrder,
        //             analysisType: this.analysisType
        //         })
        //     } else {
        //         this.$store.dispatch('CreateAudienceStore/fetchPoiData', {
        //             dataSetOrder: this.dataSetOrder,
        //             analysisType: this.analysisType
        //         })
        //     }
        // },
        // brands: function () {
        //     if ([this.analyses.types.poi, this.analyses.types.competitors, this.analyses.additional.cross_visitation].includes(this.analysisType)) {
        //         this.$store.dispatch('CreateAudienceStore/fetchLocationsByBrands', this.dataSetOrder)
        //         this.$store.dispatch('CreateAudienceStore/fetchCountriesByBrands', this.dataSetOrder)
        //     }
        // },
        // locations: function () {
        //     if (this.$store.getters['CreateAudienceStore/getLocationsSelected'](this.dataSetOrder).length) {
        //         this.$store.dispatch('CreateAudienceStore/fetchCountriesByLocations', this.dataSetOrder)
        //     }
        // },
        // countries: function () {
        //     if ([this.analyses.types.poi, this.analyses.types.competitors, this.analyses.additional.cross_visitation].includes(this.analysisType)) {
        //         this.$store.dispatch('CreateAudienceStore/fetchStatesByCountries', this.dataSetOrder)
        //         this.$store.dispatch('CreateAudienceStore/fetchDataByCountries', this.dataSetOrder)
        //     }
        // }
    }
}
</script>

<style scoped>

</style>